define('services/events/goal-events',[
    // libs
    'underscore', 'utils',
    // parent
    'src/event-aggregator'
], function(_, U, EventAggregator) {

    var GoalEvents = _.extend({}, EventAggregator.prototype, {
        goalUpdate: function(model) {
            this.trigger('goal:update', model);
        },
    });

    return GoalEvents;
});

